"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _colors = require("HubStyleTokens/colors");

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _ProductPageIcons = _interopRequireDefault(require("ui-addon-upgrades/_core/productPage/ProductPageIcons"));

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _HighlightedMerchHeaderConfig = _interopRequireDefault(require("pricing-pages-unified-ui/constants/HighlightedMerchHeaderConfig"));

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _CovidSelectors = require("../../selectors/CovidSelectors");

var _Editions = require("self-service-api/constants/Editions");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var _IncludedUnitsSubtext = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/merch-card/IncludedUnitsSubtext"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-spacing: 0;\n  width: 100%;\n  margin-bottom: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 12px 20px;\n  background-color: ", ";\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  height: 50px;\n  text-align: center;\n  width: 18.75%;\n  min-width: 175px;\n  font-weight: 500;\n\n  & > h6 {\n    margin: 0;\n  }\n\n  :first-child {\n    width: 25%;\n    text-align: left;\n  }\n\n  h2 {\n    font-size: 20px;\n  }\n\n  .growth-suite-bold {\n    font-weight: 600;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TopHeaderCell = _styledComponents.default.th.withConfig({
  displayName: "GrowthSuiteCatalogEditionHeader__TopHeaderCell",
  componentId: "sc-1momu03-0"
})(_templateObject(), _colors.OLAF, _colors.GREAT_WHITE, _colors.GREAT_WHITE);

var Table = _styledComponents.default.table.withConfig({
  displayName: "GrowthSuiteCatalogEditionHeader__Table",
  componentId: "sc-1momu03-1"
})(_templateObject2());

var GrowthSuiteCatalogEditionHeader = function GrowthSuiteCatalogEditionHeader(_ref) {
  var currencyCode = _ref.currencyCode,
      edition = _ref.edition,
      products = _ref.products,
      hub = _ref.hub,
      isHSFXEligible = _ref.isHSFXEligible,
      isLatamEsEligible = _ref.isLatamEsEligible;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var merchIdForHubEdition = (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][hub];
  var headerConfig = _HighlightedMerchHeaderConfig.default[merchIdForHubEdition];
  var includes = headerConfig.includes;
  var standalonePrice = products[merchIdForHubEdition].pricingWrap.prices.find(function (price) {
    return price.currencyCode === currencyCode;
  }).value;
  var isCovidGrowthSuitePromoEligible = (0, _reactRedux.useSelector)(_CovidSelectors.isCovidGrowthSuitePromoEligibleSelector); // Don't render discount tag while covid promo is on, as the % discount is mismatched

  var shouldRenderDiscountTag = !(isCovidGrowthSuitePromoEligible && edition === _Editions.STARTER);
  return _react.default.createElement(Table, null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement(TopHeaderCell, null, _react.default.createElement("div", {
    style: {
      float: 'left'
    }
  }, _react.default.createElement("div", null, _react.default.createElement(_UIImage.default, {
    className: "display-inline m-right-2 m-bottom-2",
    width: 15,
    src: _ProductPageIcons.default[hub]
  }), _react.default.createElement(_H.default, {
    className: "display-inline"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "pricingPage.pages.growthSuite.catalogModal." + hub + "." + edition
  }))), includes && _react.default.createElement(_IncludedUnitsSubtext.default, {
    merchandiseId: merchIdForHubEdition,
    className: "m-left-6",
    style: {
      fontWeight: 400
    }
  })), !isHSFXEligible && _react.default.createElement("div", {
    style: {
      float: 'right'
    }
  }, shouldRenderDiscountTag && _react.default.createElement("div", {
    style: {
      textAlign: 'right',
      height: '27.19px'
    },
    className: "p-top-1"
  }, _react.default.createElement(_UIBadge.default, {
    use: "new"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite." + (isLatamEsEligible ? 'latamEsPercentDiscountBadge' : 'percentDiscountBadge')
  }))), _react.default.createElement(_Small.default, {
    use: "help",
    style: {
      fontWeight: 400
    }
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage.pages.growthSuite.standalonePrice_jsx",
    options: {
      currencyCode: currencyCode,
      price: standalonePrice
    },
    elements: {
      Price: _PriceDisplay.default
    }
  })))))));
};

function mapStateToProps(state) {
  return {
    isHSFXEligible: (0, _PromotionSelectors.isHSFXEligibleSelector)(state),
    isLatamEsEligible: (0, _PromotionSelectors.isLatamEsEligibleSelector)(state)
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps)(GrowthSuiteCatalogEditionHeader);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-catalog/GrowthSuiteCatalogEditionHeader.js
// module id = 860
// module chunks = 5 6